import(/* webpackMode: "eager" */ "/vercel/path0/frontend/app/[lang]/sitemap/loading.tsx");
